/**
 * @generated SignedSource<<30e7880aba9a4552671972b5c71f210f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type InternTempoConnectButtonMutation$variables = {
  brandId: string;
};
export type InternTempoConnectButtonMutation$data = {
  readonly createTempoPartnerLink: {
    readonly id: string;
    readonly tempoApiToken: string | null;
  };
};
export type InternTempoConnectButtonMutation = {
  response: InternTempoConnectButtonMutation$data;
  variables: InternTempoConnectButtonMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "brandId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "brandId",
        "variableName": "brandId"
      }
    ],
    "concreteType": "BrandType",
    "kind": "LinkedField",
    "name": "createTempoPartnerLink",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "tempoApiToken",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "InternTempoConnectButtonMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "InternTempoConnectButtonMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "df53107f787a5591278ed89f183d7150",
    "id": null,
    "metadata": {},
    "name": "InternTempoConnectButtonMutation",
    "operationKind": "mutation",
    "text": "mutation InternTempoConnectButtonMutation(\n  $brandId: ID!\n) {\n  createTempoPartnerLink(brandId: $brandId) {\n    id\n    tempoApiToken\n  }\n}\n"
  }
};
})();

(node as any).hash = "26bc83438fb1054635b120670a2d4e97";

export default node;
